export default {
      id: "asterisk-usage",
      viewBox: "0 0 13 14",
      url: __webpack_public_path__ + "sprite.svg#asterisk",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/asterisk.svg
// module id = 131
// module chunks = 241 242 243